import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { UserProvider } from './contexts/UserContext';
import { LoginPage } from './components/Auth/LoginPage';
import { OnboardingPage } from './pages/OnboardingPage';
// Admin pages
import { AdminDashboardPage } from './pages/admin/AdminDashboardPage';
// Investor pages
import { InvestorDashboardPage } from './pages/investor/InvestorDashboardPage';
// Farmer pages
import { FarmerDashboardPage } from './pages/farmer/FarmerDashboardPage';
// Shared pages
import { ProjectListingPage } from './pages/ProjectListingPage';
import { ProjectDiscoveryPage } from './pages/ProjectDiscoveryPage';
import { DealMatchPage } from './pages/DealMatchPage';
import { ProgressUpdatePage } from './pages/ProgressUpdatePage';
import { RepaymentPage } from './pages/RepaymentPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-45">
      <UserProvider data-id="element-46">
        <Routes data-id="element-47">
          {/* Public routes */}
          <Route path="/" element={<App data-id="element-49" />} data-id="element-48" />
          <Route path="/login" element={<LoginPage data-id="element-51" />} data-id="element-50" />
          <Route path="/onboarding" element={<OnboardingPage data-id="element-53" />} data-id="element-52" />
          {/* Admin routes */}
          <Route path="/admin/dashboard" element={<AdminDashboardPage data-id="element-55" />} data-id="element-54" />
          <Route path="/admin/projects" element={<ProjectListingPage data-id="element-57" />} data-id="element-56" />
          <Route path="/admin/finance/repayments" element={<RepaymentPage data-id="element-59" />} data-id="element-58" />
          {/* Investor routes */}
          <Route path="/investor/dashboard" element={<InvestorDashboardPage data-id="element-61" />} data-id="element-60" />
          <Route path="/investor/discover" element={<ProjectDiscoveryPage data-id="element-63" />} data-id="element-62" />
          <Route path="/investor/investments" element={<ProjectListingPage data-id="element-65" />} data-id="element-64" />
          <Route path="/investor/repayments" element={<RepaymentPage data-id="element-67" />} data-id="element-66" />
          <Route path="/investor/progress" element={<ProgressUpdatePage data-id="element-69" />} data-id="element-68" />
          {/* Farmer routes */}
          <Route path="/farmer/dashboard" element={<FarmerDashboardPage data-id="element-71" />} data-id="element-70" />
          <Route path="/farmer/projects" element={<ProjectListingPage data-id="element-73" />} data-id="element-72" />
          <Route path="/farmer/funding" element={<DealMatchPage data-id="element-75" />} data-id="element-74" />
          <Route path="/farmer/progress" element={<ProgressUpdatePage data-id="element-77" />} data-id="element-76" />
          {/* Legacy routes (will redirect to appropriate user-specific routes) */}
          <Route path="/projects" element={<ProjectListingPage data-id="element-79" />} data-id="element-78" />
          <Route path="/discover" element={<ProjectDiscoveryPage data-id="element-81" />} data-id="element-80" />
          <Route path="/deals" element={<DealMatchPage data-id="element-83" />} data-id="element-82" />
          <Route path="/progress" element={<ProgressUpdatePage data-id="element-85" />} data-id="element-84" />
          <Route path="/repayments" element={<RepaymentPage data-id="element-87" />} data-id="element-86" />
        </Routes>
      </UserProvider>
    </BrowserRouter>;
}